import React from 'react';
import { LegalLayout } from './LegalLayout';
export const Privacy = () => {
  return <LegalLayout title="Política de Privacidad" data-id="element-385">
      <section className="mb-8" data-id="element-386">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-387">
          1. Tus datos están seguros
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-388">
          En Efectivo Inmediato respetamos tu privacidad.{' '}
          <span className="text-[#ADFF2F] font-semibold" data-id="element-389">
            Nunca vendemos, alquilamos ni compartimos tu información personal
            con terceros.
          </span>{' '}
          Tu correo electrónico y datos de compra se utilizan exclusivamente
          para el funcionamiento del servicio.
        </p>
      </section>

      <section className="mb-8" data-id="element-390">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-391">
          2. Qué datos recopilamos
        </h2>
        <ul className="space-y-2 text-gray-300 leading-relaxed font-sans list-disc pl-6" data-id="element-392">
          <li data-id="element-393">Tu dirección de correo electrónico (al momento de la compra)</li>
          <li data-id="element-394">Información de pago procesada por la plataforma Hotmart</li>
          <li data-id="element-395">Datos básicos de navegación (anónimos)</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-396">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-397">
          3. Cómo usamos tu información
        </h2>
        <p className="text-gray-300 leading-relaxed mb-3 font-sans" data-id="element-398">
          Tu correo electrónico se utiliza únicamente para:
        </p>
        <ul className="space-y-2 text-gray-300 leading-relaxed font-sans list-disc pl-6" data-id="element-399">
          <li data-id="element-400">Enviarte el acceso al PDF tras la compra</li>
          <li data-id="element-401">Comunicaciones relacionadas con el producto</li>
          <li data-id="element-402">Soporte técnico y atención al cliente</li>
          <li data-id="element-403">Actualizaciones del material adquirido (si aplica)</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-404">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-405">
          4. Procesamiento de pagos
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-406">
          Los pagos se procesan a través de{' '}
          <span className="text-white font-semibold" data-id="element-407">Hotmart</span>, plataforma
          que cumple con estándares internacionales de seguridad. No almacenamos
          información de tarjetas de crédito en nuestros sistemas.
        </p>
      </section>

      <section className="mb-8" data-id="element-408">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-409">
          5. Tus derechos
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-410">
          Puedes solicitar en cualquier momento que eliminemos tus datos
          personales escribiendo a{' '}
          <a href="mailto:edison_link@hotmail.com" className="text-[#ADFF2F] hover:underline" data-id="element-411">
            edison_link@hotmail.com
          </a>
          . Procesaremos la solicitud dentro de 7 días hábiles.
        </p>
      </section>

      <section data-id="element-412">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-413">
          6. Cookies y análisis
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-414">
          Esta página utiliza cookies de análisis básico (Meta Pixel) para medir
          el rendimiento de la oferta. No se utiliza esta información para
          identificarte personalmente.
        </p>
      </section>
    </LegalLayout>;
};